import React, { useState, useEffect } from "react";
// @ts-ignore
import { Scrollbars } from "react-custom-scrollbars";
import withStyles from "@material-ui/core/styles/withStyles";
import renderHTML from "react-render-html";
import API, { graphqlOperation } from "@aws-amplify/api";
import Tooltip from "@material-ui/core/Tooltip";

import withRoot from "../../withRoot";
import { styles } from "./styles";
import MessageBubble from "../baseLayout/MessagePane/MessageBubble";
import InputTextField from "./InputTextField";
import {
  getConversationsList,
  getConvo,
  GetRoraySite
} from "../../graphql/queries";
import { createConvo, createConvoLink } from "../../graphql/mutations";

const fetchUserConversations = async (id: any, client: any) => {
  let a = await client.query({
    query: getConversationsList,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  });
  return a;
};

const fetchMessages = async (id: any, client: any) => {
  return await client.query({
    query: getConvo,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  });
};

interface ISimpleChatBotProps {
  classes: any;
  client: any;
  activeConversation: any;
  userId: any;
  setActiveConversation: Function;
}

const SimpleChatBot: React.FC<ISimpleChatBotProps> = ({
  classes,
  client,
  userId,
  activeConversation,
  setActiveConversation
}) => {
  const localUserId = localStorage.getItem("randUserIdAws")
    ? localStorage.getItem("randUserIdAws")
    : "abc";

  const [botText, updateBotText] = useState("");
  const [defineText, updateDefineText] = useState("");
  const [allText, setallText] = useState("");
  const [convoid, updateid] = useState("");
  const [name, updatename] = useState("");
  const [mainData, setmainData] = useState("");
  const [autoSend, setAutoSend] = useState(false);
  const [pageData, setPageData] = useState();
  const [dummyMessages, updateMessages]: [Array<any>, any] = useState([]);
  const [open, setOpen] = React.useState(false);

  let scrollRef: any = React.createRef();

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollToBottom();
  }, [dummyMessages]);

  useEffect(() => {
    getHTMLData();
  });

  const getHTMLData = async () => {
    const helpData: any = await API.graphql(
      graphqlOperation(GetRoraySite, {
        siteId: process.env.REACT_APP_GLOBAL_SITEID,
        typeValue: "pages::honeycode-glossary-chat-main"
      })
    );
    let content =
      helpData.data.getRoraySiteN4udipg3snevddjjskvzzepdhaJcdev.content;
    let temp = htmlDecode(content);
    if (content !== null) {
      setPageData(temp);
    }
  };

  const htmlDecode = (input: any) => {
    var e = document.createElement("textarea");
    e.innerHTML = input;
    return e.value;
  };

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollToBottom();
    async function fetchData() {
      let data = await fetchUserConversations(localUserId, client);
      let messages = [];
      let id = "";

      if (
        data.data.getUser !== null &&
        typeof data.data.getUser.userConversations.items !== "undefined" &&
        data.data.getUser.userConversations.items.length > 0
      ) {
        id = data.data.getUser.userConversations.items[0].conversation.id;
        let m = await fetchMessages(id, client);
        setActiveConversation(data.data.getUser.userConversations.items[0]);
        messages = m.data.getConvo.messages.items.reverse();
      } else {
        const data: any = await client.mutate({
          mutation: createConvo,
          variables: {
            input: { name: "direct" }
          }
        });
        const createConvoResponse = data.data.createConvo;
        const userConvoLink = client.mutate({
          mutation: createConvoLink,
          variables: {
            convoId: createConvoResponse.id,
            userId: localUserId,
            name: "norpac-bot"
          }
        });

        setActiveConversation({
          id: createConvoResponse.id,
          name: "NORPAC",
          conversation: { id: createConvoResponse.id }
        });
        id = createConvoResponse.id;
      }

      updateid(id);
      updatename(`norpac-user-${localUserId}`);
      updateMessages(messages);
    }
    fetchData();
  }, []);

  const autoMessage = (messageData: any) => {
    setAutoSend(true);
    localStorage.setItem("slugTerm", messageData.slugTerm);
    localStorage.setItem("slugTermMain", messageData);
    updateBotText(`Define${" "+messageData}`);
    updateDefineText(`Define${" " +messageData}`);
    localStorage.setItem("slugTermMain", `Define${" " + messageData}`);
    setTimeout(() => {
      setAutoSend(false);
    }, 1000);
  };

  const saveChatTagDataMain = (data: any) => {
    updateBotText("Define  " + `${data} > ` + `${allText}`);
    // updateBotText("Define  " + `${data}`);
    setmainData("Define  " + `${data}>${allText}`);
  };

  const saveSliderDataMain = (slidersData: any) => {
    setallText(slidersData);
  };

  const updateBotTextMsg = (text: any) => {
    updateBotText(text);
    if (text !== "") {
      updateDefineText(text);
    }
  };

  const updateURLText = (text: any) => {
    updateDefineText(text);
  };

  const setQRScroll = () => {
    setTimeout(() => {
      scrollRef.current.scrollToBottom();
    }, 400);
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  return (
    <div className={classes.messagePaneRoot}>
      {dummyMessages.length == 0 ? (
        <div className={classes.messagePaneRootText}>
          {/* {pageData && renderHTML(pageData)} */}
          {/* <Tooltip
                PopperProps={{
                  disablePortal: true,
                }}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title="Add"
              > */}
          {/* <a target="_blank" href={`https://tehillim.glossary.chat/`} > */}
          {pageData && renderHTML(pageData)}
          {/* </a> */}
          {/* </Tooltip> */}
        </div>
      ) : (
        <Scrollbars ref={scrollRef} autoHeight autoHeightMax={"80vh"}>
          <div className={classes.chathei} />
          <div className={classes.messagePaneRootText}>
            {/* <a target="_blank" href={`https://tehillim.glossary.chat/`}> */}
            {pageData && renderHTML(pageData)}
            {/* </a> */}
          </div>
          {dummyMessages.map((message: any, index: number) => (
            <MessageBubble
              authorId={userId}
              message={message}
              saveChatTagDataMain={saveChatTagDataMain}
              saveSliderDataMain={saveSliderDataMain}
              key={index}
              botText={defineText}
              client={client}
              autoMsg={autoMessage}
              setQRScroll={setQRScroll}
            />
          ))}
        </Scrollbars>
      )}

      <InputTextField
        client={client}
        authorId={userId}
        activeConversation={activeConversation}
        dummyMessages={dummyMessages}
        updateMessages={updateMessages}
        botText={botText}
        updateBotText={updateBotTextMsg}
        autoSend={autoSend}
        classes={classes}
        updateURLText={updateURLText}
      />
    </div>
  );
};

export default withRoot(withStyles(styles)(SimpleChatBot));
